import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type {
  CatalogCardCategoriesListResponseData,
  CatalogCardShowResponseData,
  ClientCardCategoriesListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

const CATALOG_TREE_PAGE_SIZE = 1000;

type CatalogCardCategoriesParams = {
  url: string;
  filters?: Record<string, unknown>;
};

export const catalogCardKeys = {
  all: () => ['catalogCards'] as const,
  categories: (props: CatalogCardCategoriesParams) =>
    [...catalogCardKeys.all(), 'categories', props.url, props.filters] as const,
  clientCategories: (props: { url: string }) =>
    [...catalogCardKeys.all(), 'clientCategories', props.url] as const,
  detail: (props: { url: string }) =>
    [...catalogCardKeys.all(), 'detail', props.url] as const,
};

export const catalogCardQueries = {
  categories: (props: CatalogCardCategoriesParams) =>
    queryOptions({
      queryKey: catalogCardKeys.categories(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<CatalogCardCategoriesListResponseData>({
              method: 'GET',
              url: props.url,
              params: {
                size_per_page: CATALOG_TREE_PAGE_SIZE,
                ...(props.filters ? { filters: props.filters } : {}),
              },
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),

  clientCategories: (props: { url: string }) =>
    queryOptions({
      queryKey: catalogCardKeys.clientCategories(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<ClientCardCategoriesListResponseData>({
              method: 'GET',
              url: props.url,
              params: { size_per_page: CATALOG_TREE_PAGE_SIZE },
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),

  detail: (props: { url: string }) =>
    queryOptions({
      queryKey: catalogCardKeys.detail(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<CatalogCardShowResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: true,
      placeholderData: keepPreviousData,
    }),
};
